import type { T } from '@common/hooks/useTranslation';

export function ageVerificationConsentRules(t: T) {
  return {
    required: t('validations.general.ageConsent.required')
  };
}
